import React from 'react';
import './MarketMenu.css';


const ServingsDropdown = ({ variants, selectedVariant, handleVariantChange }) => {
    return (
        <select
            className='servings_select'
            name="selected_variant"
            value={selectedVariant?.id} // Use selectedVariant.id for the select value
            onChange={(e) => {
                handleVariantChange(e.target.value); // Pass the selected variant ID to the handler
            }}>
            {variants.map((variant) => (
                <option key={variant.id} value={variant.id}> {/* Use variant.id here */}
                    {variant.servings} servings
                </option>
            ))}
        </select>
    );
}

export default ServingsDropdown;
